import { render, staticRenderFns } from "./MigrateDai.vue?vue&type=template&id=f89b19ec&scoped=true&"
import script from "./MigrateDai.vue?vue&type=script&lang=js&"
export * from "./MigrateDai.vue?vue&type=script&lang=js&"
import style0 from "./MigrateDai.vue?vue&type=style&index=0&id=f89b19ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89b19ec",
  null
  
)

export default component.exports